import { PermissionT } from "../types";

export const enterpriseAdminPro = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "enterprise_admin_pro");
  return !!p;
};
export default enterpriseAdminPro;
